/**
 * Container en packing list comercial (invoice): clave, edición y relleno (celdas fusionadas en Excel).
 */

import { packingListContainerKey } from './packingListGradeSort';

export { packingListContainerKey };

export function containerFieldsFromInput(v) {
  const t = v != null ? String(v).trim() : '';
  if (!t) {
    return { container_celda: '', _container_excel: '', _container: null };
  }
  const normalized = String(t).replace(/\s/g, '').replace(',', '.');
  const n = parseFloat(normalized);
  const isPureNumber = /^-?\d+(?:\.\d+)?$/.test(normalized);
  return {
    container_celda: t,
    _container_excel: t,
    _container: isPureNumber && Number.isFinite(n) ? n : null,
  };
}

function snapshotFromRow(r) {
  const key = packingListContainerKey(r);
  if (!key) return null;
  const t = String(r.container_celda ?? r._container_excel ?? key).trim() || key;
  const fields = containerFieldsFromInput(t);
  return {
    container_celda: fields.container_celda,
    _container_excel: fields._container_excel,
    _container: r._container != null ? r._container : fields._container,
  };
}

/** Rellena container vacío hacia abajo (Excel con celdas fusionadas en columna Container). */
export function forwardFillContainerInDetalle(rows) {
  let last = null;
  return (rows || []).map((r) => {
    const snap = snapshotFromRow(r);
    if (snap) {
      last = snap;
      return { ...r, ...snap };
    }
    if (!last) return r;
    return { ...r, ...last };
  });
}
